import {
    getInvoiceItem,
    listInvoiceItems
} from './queries';

import {GraphQLQuery,} from '@aws-amplify/api';
import {InvoiceItem} from "../types.ts";
import { billingApiClient } from "../../billing-api-integration";
import {ListRecordsQuery} from "../../../types";


export type ListInvoiceItems = {
    listInvoiceItems: { items: InvoiceItem[], nextToken: string }
}

export type GetInvoiceItem = {
    getInvoiceItem: InvoiceItem
}

const client = billingApiClient;


export const fetchRecords = async (
    query: ListRecordsQuery & { filter?: { invoiceId?: string, customerId?: string } },
) => {
    const response = await client.graphql<GraphQLQuery<ListInvoiceItems>>({
                                                                              query: listInvoiceItems,
                                                                              variables: {
                                                                                  ...query,
                                                                              },
                                                                          });
    return {
        items: response.data?.listInvoiceItems.items,
        nextToken: response.data?.listInvoiceItems.nextToken
    }
};

export const fetch = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<GetInvoiceItem>>({
                                                                            query: getInvoiceItem,
                                                                            variables: {
                                                                                id,
                                                                            },
                                                                        });
    return response.data?.getInvoiceItem;
};
